import sliceCreator from '../../index.jsx';
import { UPDATE_ACTIVITY} from '../../../constants/index.jsx';
const _updateActivityAction = sliceCreator('UPDATE_ACTIVITY', UPDATE_ACTIVITY, 'put');

const { asyncAction: updateActivityAction, reducer, clearData: clearUpdateActivityAction } = _updateActivityAction;

export default reducer;

export {
    updateActivityAction,
    clearUpdateActivityAction
}